import * as React from 'react';

const FreeDeliveryActive = (props) => (
  <svg
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.41602 23.0689C7.9348 23.0689 9.16602 21.8377 9.16602 20.3189C9.16602 18.8001 7.9348 17.5689 6.41602 17.5689C4.89723 17.5689 3.66602 18.8001 3.66602 20.3189C3.66602 21.8377 4.89723 23.0689 6.41602 23.0689Z"
      stroke="white"
      strokeWidth={0.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.41602 24.5688C8.21094 24.5688 9.66602 23.1138 9.66602 21.3188C9.66602 19.5239 8.21094 18.0688 6.41602 18.0688C4.62109 18.0688 3.16602 19.5239 3.16602 21.3188C3.16602 23.1138 4.62109 24.5688 6.41602 24.5688Z"
      fill="url(#paint0_linear_1856_36846)"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.791 23.0689C20.3098 23.0689 21.541 21.8377 21.541 20.3189C21.541 18.8001 20.3098 17.5689 18.791 17.5689C17.2722 17.5689 16.041 18.8001 16.041 20.3189C16.041 21.8377 17.2722 23.0689 18.791 23.0689Z"
      stroke="white"
      strokeWidth={0.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.791 24.5688C20.5859 24.5688 22.041 23.1138 22.041 21.3188C22.041 19.5239 20.5859 18.0688 18.791 18.0688C16.9961 18.0688 15.541 19.5239 15.541 21.3188C15.541 23.1138 16.9961 24.5688 18.791 24.5688Z"
      fill="url(#paint1_linear_1856_36846)"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9033 10.708L16.041 13.8472V19.9439H11.916V14.4439H2.29102V15.8189H6.41602V17.1939C5.322 17.1939 4.27279 17.6285 3.4992 18.4021C2.72561 19.1757 2.29102 20.2249 2.29102 21.3189H18.791L21.7088 18.4039C21.3262 18.0198 20.8715 17.7152 20.3707 17.5075C19.87 17.2998 19.3331 17.1933 18.791 17.1939V15.8189L17.416 14.4439L18.8051 13.0562L14.6801 8.93115L12.9033 10.708ZM2.29102 10.3189H7.79102V13.0689H2.29102V10.3189ZM18.791 10.3189H17.416C17.0513 10.3189 16.7016 10.4638 16.4437 10.7216C16.1859 10.9795 16.041 11.3292 16.041 11.6939C16.041 12.0586 16.1859 12.4083 16.4437 12.6662C16.7016 12.924 17.0513 13.0689 17.416 13.0689H18.791V10.3189Z"
      fill="url(#paint2_linear_1856_36846)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.196 11.415C11.8056 11.0244 11.8057 10.3914 12.1962 10.0009L13.973 8.22405C14.3636 7.83352 14.9967 7.83352 15.3872 8.22405L16.6196 9.45641C16.8729 9.36625 17.142 9.3189 17.416 9.3189H18.791C19.3433 9.3189 19.791 9.76662 19.791 10.3189V12.8886C19.8004 12.9437 19.8052 12.9998 19.8051 13.0564C19.8051 13.3217 19.6996 13.5761 19.5119 13.7636L18.8306 14.4443L19.4981 15.1118C19.6857 15.2993 19.791 15.5537 19.791 15.8189V16.2917C20.12 16.357 20.4425 16.4547 20.7538 16.5838C21.3763 16.842 21.9417 17.2207 22.4173 17.6982C22.8066 18.0891 22.8058 18.7214 22.4155 19.1113L19.4978 22.0263C19.3103 22.2137 19.0561 22.3189 18.791 22.3189H2.29102C2.0258 22.3189 1.77145 22.2135 1.58391 22.026C1.39637 21.8385 1.29102 21.5841 1.29102 21.3189C1.29102 19.9597 1.83097 18.6561 2.79209 17.695C3.14178 17.3453 3.53679 17.0514 3.96332 16.8189H2.29102C1.73873 16.8189 1.29102 16.3712 1.29102 15.8189V14.4439C1.29102 14.1776 1.39511 13.9356 1.56483 13.7564C1.39511 13.5772 1.29102 13.3352 1.29102 13.0689V10.3189C1.29102 9.76662 1.73873 9.3189 2.29102 9.3189H7.79102C8.3433 9.3189 8.79102 9.76662 8.79102 10.3189V13.0689C8.79102 13.2015 8.7652 13.3281 8.71833 13.4439H11.916C12.4683 13.4439 12.916 13.8916 12.916 14.4439V18.9439H15.041V14.2612L12.196 11.415ZM16.041 13.8472V19.9439H11.916V14.4439H2.29102V15.8189H6.41602V17.1939C5.322 17.1939 4.27279 17.6285 3.4992 18.4021C2.96601 18.9353 2.59386 19.5994 2.41405 20.3189C2.33298 20.6433 2.29102 20.9789 2.29102 21.3189H18.791L21.7088 18.4039C21.7058 18.4009 21.7028 18.3979 21.6998 18.395C21.4637 18.1593 21.2003 17.9539 20.9158 17.7826C20.7416 17.6778 20.5594 17.5858 20.3707 17.5075C19.873 17.3011 19.3395 17.1945 18.8007 17.1939C18.7974 17.1939 18.7942 17.1939 18.791 17.1939V15.8189L17.416 14.4439L18.791 13.0703L18.7924 13.0689L18.8051 13.0562L18.791 13.042V10.3189H17.416C17.0577 10.3189 16.7138 10.4588 16.4573 10.7083L14.6801 8.93115L12.9033 10.708L16.041 13.8472ZM17.378 13.0684C17.3865 13.0686 17.3951 13.0688 17.4036 13.0688C17.4078 13.0689 17.4119 13.0689 17.416 13.0689H18.791V13.042L16.4573 10.7083C16.4527 10.7127 16.4482 10.7171 16.4437 10.7216C16.1859 10.9795 16.041 11.3292 16.041 11.6939C16.041 11.698 16.041 11.7022 16.0411 11.7063C16.0443 12.0665 16.1888 12.4112 16.4437 12.6662C16.6926 12.9151 17.0271 13.0587 17.378 13.0684ZM2.29102 10.3189V13.0689H7.79102V10.3189H2.29102Z"
      fill="black"
    />
    <circle cx={20.666} cy={7} r={6.5} fill="#B8238E" stroke="#7D005A" />
    <path
      d="M17.166 7.05357L19.4993 9.625L24.166 4.375"
      stroke="white"
      strokeWidth={2}
    />
    <defs>
      <linearGradient
        id="paint0_linear_1856_36846"
        x1={3.66602}
        y1={24.0688}
        x2={11.333}
        y2={21.1324}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9C132" />
        <stop offset={1} stopColor="#F9ED32" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1856_36846"
        x1={16.041}
        y1={24.0688}
        x2={23.708}
        y2={21.1324}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9C132" />
        <stop offset={1} stopColor="#F9ED32" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1856_36846"
        x1={2.29102}
        y1={21.3189}
        x2={25.1066}
        y2={7.62137}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F9C132" />
        <stop offset={1} stopColor="#F9ED32" />
      </linearGradient>
    </defs>
  </svg>
);
export default FreeDeliveryActive;
